<script>
import modalCsvImport from "../modals/modal-csv-import.vue";
import sort from "fast-sort";

export default {
  name: "contactList",
  components: {
    modalCsvImport,
  },
  data() {
    return {
      approvers: [],
      searchValue: "",
      selectedApproverIds: {},
      currentPage: 1,
      perPage: 10,
      selectAllModel: false,
      someSelectedModel: false,
      fields: [
        { key: "select", label: "", tdClass: "select-cell", thClass: "select-cell" },
        { key: "name", label: "Name", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "frequency", label: "Frequency", sortable: true },
        { key: "totalProofs", label: "Total Proofs", sortable: true },
        { key: "createdAt", label: "Created", sortable: true },
        {
          key: "edit",
          label: "",
          tdClass: "action-cell",
          thClass: "action-cell",
        },
        {
          key: "menu",
          label: "",
          tdClass: "action-cell action-cell-menu",
          thClass: "action-cell action-cell-menu",
        },
      ],
    };
  },
  async mounted() {
    await this.$A.GetCurAccountData();
    await this.loadAllApprovers();

    const self = this;
    this.$root.$on("delete::approver::confirmed", async () => {
      const approverIds = Object.keys(self.selectedApproverIds);
      await self.$A.ApproverService.Delete(approverIds);
      self.selectedApproverIds = {};
      self.refreshSelectModel();
      await self.loadAllApprovers();
    });
  },
  computed: {
    filteredApprovers() {
      const term = this.searchValue.toLowerCase();
      if (!term) return this.approvers;
      return this.approvers.filter((a) => {
        const name = (a.name || "").toLowerCase();
        const email = (a.email || "").toLowerCase();
        return name.indexOf(term) !== -1 || email.indexOf(term) !== -1;
      });
    },
    hasSelectedApprovers() {
      return Object.keys(this.selectedApproverIds).length > 0;
    },
  },
  watch: {
    filteredApprovers() {
      this.refreshSelectModel();
    },
    currentPage() {
      this.resetSelectedApprovers();
    },
    perPage() {
      this.resetSelectedApprovers();
    },
    searchValue() {
      this.currentPage = 1;
    },
  },
  methods: {
    async loadAllApprovers() {
      this.approvers = (await this.$A.ApproverService.All()) || [];
      sort(this.approvers).desc((a) => a.id);
    },
    createApprover() {
      this.$A.NavigateToView("/approver-item", {});
    },
    editApprover(approver) {
      this.$A.NavigateToView(`/contact-details?id=${approver.id}`, { approver });
    },
    openImportModal() {
      this.$refs.csvImportModal.open();
    },
    async handleImportCompleted(results) {
      if (results.successful > 0) {
        this.$A.AlertUser(
          `Successfully imported ${results.successful} contacts!`,
          "success",
          5000
        );
        await this.loadAllApprovers();
      }
      if (results.failed > 0) {
        this.$A.AlertUser(
          `${results.failed} contacts failed to import. Check the import results for details.`,
          "warning",
          8000
        );
      }
    },
    queueRowDelete(approverId) {
      this.selectedApproverIds = { [approverId]: true };
    },
    onSelectAllChange(checked) {
      this.selectedApproverIds = {};
      const start = (this.currentPage - 1) * this.perPage;
      if (checked) {
        this.filteredApprovers
          .slice(start, start + this.perPage)
          .forEach((a) => {
            this.selectedApproverIds[a.id] = true;
          });
      }
      this.someSelectedModel = false;
    },
    onSelectChange(id, checked) {
      if (!checked) {
        delete this.selectedApproverIds[id];
      } else {
        this.selectedApproverIds[id] = true;
      }
      this.refreshSelectModel();
    },
    resetSelectedApprovers() {
      this.selectedApproverIds = {};
      this.selectAllModel = false;
      this.someSelectedModel = false;
    },
    refreshSelectModel() {
      for (const [key, value] of Object.entries(this.selectedApproverIds)) {
        if (!value) delete this.selectedApproverIds[key];
      }
      const selectedCount = Object.keys(this.selectedApproverIds).length;
      const start = (this.currentPage - 1) * this.perPage;
      const pageCount = this.filteredApprovers.slice(start, start + this.perPage).length;
      if (selectedCount > 0 && pageCount > 0 && selectedCount === pageCount) {
        this.selectAllModel = true;
        this.someSelectedModel = false;
      } else if (selectedCount > 0) {
        this.selectAllModel = false;
        this.someSelectedModel = true;
      } else {
        this.selectAllModel = false;
        this.someSelectedModel = false;
      }
    },
  },
};
</script>

<template>
  <div class="contact-list-wrapper">
    <b-card class="contact-list-card account-contact-card">
      <b-card-body>
        <!-- Toolbar -->
        <div class="card-toolbar">
          <div class="toolbar-left">
            <b-input-group class="contact-search">
              <b-input-group-prepend>
                <b-input-group-text class="contact-search-input bg-white">
                  <b-icon-search />
                </b-input-group-text>
              </b-input-group-prepend>
              <b-form-input
                class="contact-search-input border-left-0 pl-0"
                v-model="searchValue"
                type="text"
                placeholder="Search contacts..."
                maxlength="30"
              />
            </b-input-group>
            <div class="toolbar-count">
              {{ filteredApprovers.length }}
              {{ filteredApprovers.length === 1 ? "contact" : "contacts" }}
            </div>
          </div>
          <div class="toolbar-right">
            <b-button
              v-if="hasSelectedApprovers"
              v-b-modal.deleteApproverModal
              class="delete-contact-btn"
            >
              Delete
            </b-button>
            <b-dropdown
              variant="link"
              toggle-class="toolbar-menu-toggle"
              menu-class="row-menu"
              no-caret
              right
              no-flip
              boundary="viewport"
              offset="4"
            >
              <template #button-content>
                <b-icon-three-dots-vertical />
                <span class="sr-only">More actions</span>
              </template>
              <b-dropdown-item @click="openImportModal">
                Import contacts
              </b-dropdown-item>
            </b-dropdown>
            <a
              id="approver_button"
              class="button button-light button-green contacts-btn mb-0"
              @click="createApprover"
            >
              Create Contact
            </a>
          </div>
        </div>

        <!-- Table -->
        <b-table
          v-if="filteredApprovers.length"
          id="approver_table"
          class="contact-table mb-0"
          :items="filteredApprovers"
          :fields="fields"
          responsive
          hover
          :no-provider-paging="true"
          :no-provider-sorting="true"
          :per-page="perPage"
          :current-page="currentPage"
          tbody-tr-class="contact-row"
          @row-clicked="editApprover"
        >
          <template #head()="data">
            <span class="column-header-text">{{ data.label }}</span>
          </template>
          <template #head(select)>
            <b-form-checkbox
              id="approver_table_header"
              class="item-checkbox"
              @change="onSelectAllChange"
              v-model="selectAllModel"
              :indeterminate="someSelectedModel"
            />
          </template>
          <template #cell(select)="data">
            <span @click.stop>
              <b-form-checkbox
                class="item-checkbox"
                @change="(checked) => onSelectChange(data.item.id, checked)"
                v-model="selectedApproverIds[data.item.id]"
              />
            </span>
          </template>
          <template #cell(createdAt)="data">
            {{ $A.FormatDateToString(data.item.createdAt) }}
          </template>
          <template #cell(edit)="data">
            <button
              class="row-edit-btn"
              @click.stop="editApprover(data.item)"
            >
              Edit
            </button>
          </template>
          <template #cell(menu)="data">
            <span @click.stop>
              <b-dropdown
                variant="link"
                toggle-class="row-menu-toggle"
                menu-class="row-menu"
                no-caret
                right
                no-flip
                boundary="viewport"
                offset="4"
              >
                <template #button-content>
                  <b-icon-three-dots-vertical />
                  <span class="sr-only">More actions</span>
                </template>
                <b-dropdown-item
                  :data-cy="`delete-${data.item.name}`"
                  v-b-modal.deleteApproverModal
                  @click="queueRowDelete(data.item.id)"
                >
                  Delete
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </template>
          <template slot="custom-foot">
            <b-tr class="contact-foot">
              <b-td colspan="4">
                <div class="d-flex align-items-center">
                  <span class="pr-2">Rows Per Page</span>
                  <b-form-select
                    v-model="perPage"
                    :options="[10, 20, 50, 100]"
                    size="sm"
                    style="width: fit-content"
                  />
                </div>
              </b-td>
              <b-td colspan="4">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="filteredApprovers.length"
                  :per-page="perPage"
                  aria-controls="approver_table"
                  align="right"
                  size="md"
                  page-class="customPage"
                  class="p-0 m-0"
                >
                  <template #page="{ page }">
                    <span class="customPage">{{ page }}</span>
                  </template>
                </b-pagination>
              </b-td>
            </b-tr>
          </template>
        </b-table>

        <!-- Empty state -->
        <div class="null-item" v-else>
          <div class="row">
            <div class="col-md-12">
              <img src="/img/hook-icon.svg" />
              <h4>You Do Not Currently Have Any Contacts</h4>
              <p>
                You can add a contact by selecting the "Create Contact" button
                above.
              </p>
            </div>
          </div>
        </div>

        <!-- Modals -->
        <modal
          name="deleteApproverModal"
          eventToEmitOnConfirmation="delete::approver::confirmed"
          question="Delete This Contact?"
          body="Are you sure you want to delete this contact? You cannot undo this action."
          confirm-button-text="Yes, Delete"
        />
        <modalCsvImport
          ref="csvImportModal"
          @import-completed="handleImportCompleted"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<style scoped>
.contact-list-wrapper {
  background-color: #eef2f5;
  padding: 24px 24px 48px;
}

.contact-list-card {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
}

::v-deep .account-contact-card .card-body {
  padding: 0px;
}

.card-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  border-bottom: 1px solid #e5e7eb;
  gap: 16px;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1 auto;
  min-width: 0;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.contact-search {
  max-width: 280px;
}

.contact-search-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 9px 13px;
  height: 38px;
  border: 1px solid #b5b5b8;
  box-shadow: 0px 1px 2px rgba(8, 11, 13, 0.05);
  border-radius: 6px;
}

::v-deep .contact-search .form-control:focus {
  outline: 0;
  box-shadow: none;
  border-color: #b5b5b8 !important;
  border-left: none;
}

.toolbar-count {
  font-family: "Open Sans";
  font-size: 13px;
  color: #6b7280;
  white-space: nowrap;
}

::v-deep .contact-table table {
  margin-bottom: 0;
}

::v-deep .contact-table table th {
  background: #f9fafb;
  border-top: 0;
  border-bottom: 1px solid #e5e7eb;
  padding: 10px 24px !important;
  vertical-align: middle !important;
}

::v-deep .contact-table table td {
  padding: 14px 24px !important;
  vertical-align: middle !important;
  border-top: 1px solid #f1f2f4;
  border-bottom: 0;
}

::v-deep .contact-table tbody tr:first-child td {
  border-top: 0;
}

::v-deep .contact-table table td.action-cell,
::v-deep .contact-table table th.action-cell {
  width: 1%;
  white-space: nowrap;
  text-align: right;
  padding-left: 4px !important;
  padding-right: 4px !important;
}

::v-deep .contact-table table td.action-cell-menu,
::v-deep .contact-table table th.action-cell-menu {
  padding-left: 0 !important;
  padding-right: 16px !important;
}

::v-deep .contact-table table td.select-cell,
::v-deep .contact-table table th.select-cell {
  width: 1%;
  padding-right: 4px !important;
}

::v-deep .contact-row {
  cursor: pointer;
}

::v-deep .contact-table.table-hover tbody tr:hover,
::v-deep .contact-table tbody tr:hover {
  background-color: #f9fafb;
  color: inherit;
}

::v-deep .contact-foot td {
  border-top: 1px solid #e5e7eb !important;
  padding: 12px 24px !important;
}

.column-header-text {
  font-family: "Open Sans";
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.row-edit-btn {
  background: transparent;
  border: 1px solid #d1d5db;
  color: #1b1b1c;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 16px;
  border-radius: 6px;
  line-height: 20px;
}

.row-edit-btn:hover {
  background: #ffffff;
  border-color: #b4b9c0;
}

.row-edit-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(107, 114, 128, 0.2);
}

::v-deep .row-menu-toggle,
::v-deep .toolbar-menu-toggle {
  color: #6b7280;
  padding: 4px 6px;
  border-radius: 4px;
}

::v-deep .row-menu-toggle:hover,
::v-deep .row-menu-toggle:focus,
::v-deep .toolbar-menu-toggle:hover,
::v-deep .toolbar-menu-toggle:focus {
  color: #1b1b1c;
  background-color: #f1f2f4;
  text-decoration: none;
  box-shadow: none;
}

::v-deep .row-menu {
  min-width: 8rem;
  font-size: 14px;
}

.contacts-btn {
  padding: 9px 17px !important;
  font-weight: normal;
  height: 38px;
  background: #019256;
  box-shadow: 0px 1px 2px rgba(8, 11, 13, 0.05);
  border-radius: 6px;
}

.delete-contact-btn {
  padding: 8px 16px;
  height: 38px;
  box-shadow: 0px 1px 2px rgba(8, 11, 13, 0.05);
  border-radius: 6px;
  font-family: "Open Sans";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #eb4654;
  background-color: white;
  border: 1px solid #eb4654;
}

/* Checkbox styling (preserved from prior table) */
::v-deep .item-checkbox .custom-control-label::before {
  top: 0.2rem;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  background: white;
  border: 1px solid #b5b5b8;
  border-radius: 4px;
  color: black;
}

::v-deep .item-checkbox .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none;
}

::v-deep .item-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #006f41;
}

::v-deep .item-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  background: #95d6b0 !important;
}

::v-deep .item-checkbox .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border: 1px solid #b5b5b8 !important;
}

/* Pagination (preserved) */
.customPage {
  color: #212529 !important;
}

::v-deep .customPage {
  color: #212529 !important;
}

::v-deep .page-item .page-link {
  color: #019256 !important;
}

::v-deep .page-item.disabled .page-link {
  color: #6c757d !important;
}

::v-deep .customPage.page-item.active .page-link {
  background-color: #ebebed;
  border-color: #019256;
  color: #019256;
}

::v-deep .customPage.page-item.active .page-link .customPage {
  color: #019256 !important;
}

/* Empty state */
.null-item {
  list-style-type: none;
  text-align: center;
  padding: 48px 16px;
}

.null-item img {
  height: 100px;
  margin-bottom: 25px;
  animation: hook 5s infinite;
}

.null-item h4 {
  margin-bottom: 15px;
}

@-webkit-keyframes hook {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

@media (max-width: 576px) {
  .contact-list-wrapper {
    padding: 12px 12px 32px;
  }

  .card-toolbar {
    padding: 12px 16px;
    flex-direction: column;
    align-items: stretch;
  }

  .toolbar-left,
  .toolbar-right {
    width: 100%;
    justify-content: space-between;
  }

  .contact-search {
    max-width: none;
    flex: 1;
  }

  .contacts-btn {
    padding: 8px !important;
    border-radius: 5px;
    font-weight: normal !important;
  }
}
</style>
